import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate, useParams } from 'react-router-dom'

import { Spinner } from '@dashboard/ui'
import { useCreatorTerm } from '@/layouts/creator/hooks'
import { CreatorAcceptTermsForm } from '@/layouts/creator/widgets/CreatorAcceptTermsForm'
import { CreatorTokenProvider } from '@/layouts/creator/provider'

export const CreatorAcceptTermsPage = () => {
  const { t } = useTranslation()
  const { token } = useParams() as { token: string }
  const navigate = useNavigate()

  const { accepted, isLoading, isError } = useCreatorTerm(token)

  useEffect(() => {
    isError && navigate(`/creator/${token}/error`)
    accepted && navigate(`/creator/${token}/terms/accepted`)
  }, [isError, accepted, navigate, token])

  return (
    <div
      style={{
        width: '580px',
        boxShadow: '0px 24px 48px -12px #1018282E',
        background: 'linear-gradient(273.02deg, rgba(255, 255, 255, 0) 5.02%, #FFFFFF 94.98%)',
        zIndex: 1,
      }}
      className="flex min-h-fit flex-col justify-center gap-[18px] rounded-2xl1 bg-fg-primary p-12"
    >
      {isLoading || accepted ? (
        <div className="flex size-full items-center justify-center">
          <Spinner size={48} />
        </div>
      ) : (
        <>
          <div className="flex flex-col gap-1.5">
            <span className="text-h2 font-semibold">{t('creator.terms.title')}</span>
            <span className="text-paragraph-sm font-medium text-text-secondary">{t('creator.terms.text')}</span>
          </div>

          <CreatorTokenProvider token={token}>
            <CreatorAcceptTermsForm />
          </CreatorTokenProvider>
        </>
      )}
    </div>
  )
}
